import api from './index';

export const apiGetDashs = async (companyId) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/dashboard`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetInvoices = async (companyId, payload) => {
  const { offset, limit, interval } = payload
  try {
    const { data } = await api.get(`/companies/${companyId}/nfs?offset=${offset}&limit=${limit}&interval=${interval}`)
    return data
  } catch (err) {
    throw err
  }
}

export const apiGetPaymentTickets = async (companyId, payload) => {
  const { offset, limit, interval, filter } = payload
  const haveFilter = filter ? `&filter=${filter}` : ''
  try {
    const { data } = await api.get(`/companies/${companyId}/payment-ticket?offset=${offset}&limit=${limit}&interval=${interval}${haveFilter}`)
    return data
  } catch (err) {
    throw err
  }
}
